'use client';

import { useAreFeatureFlagsLoading } from '@frameio/feature-flags';
import { useGetRootCollectionForProjectQuery } from '@frameio/graphql-client/generated';
import { NavigationMenuContextProvider } from '@frameio/project-tree/contexts';
import { StaticProjectNav } from './components';
import { ProjectNavigationActivationManager } from './components/ProjectNavActivationManager/ProjectActivationManager';

export const ProjectNavigation = ({
  projectId,
  rootFolderId,
}: {
  projectId: string;
  rootFolderId?: string;
}) => {
  const featureFlagsLoading = useAreFeatureFlagsLoading();

  // make sure the visible field information is loaded for the root collection,
  // otherwise the FolderTree won't be able to hydrate
  useGetRootCollectionForProjectQuery({
    variables: {
      projectId,
    },
    skip: !projectId,
  });

  if (!projectId || featureFlagsLoading) return null;

  return (
    <NavigationMenuContextProvider>
      <ProjectNavigationActivationManager rootFolderId={rootFolderId ?? ''}>
        <StaticProjectNav projectId={projectId} rootFolderId={rootFolderId} />
      </ProjectNavigationActivationManager>
    </NavigationMenuContextProvider>
  );
};
